<template>
  <div>
    <div v-if="!visible">
      <slot></slot>
    </div>
    <div v-else>
      <Loader :visible="!visible" />
    </div>
  </div>
</template>

<script>
import Loader from './Loader'

export default {
  name: 'Loading',
  components: { Loader },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped></style>
